module.exports = __webpack_public_path__ + "files/2fdbf25c9ba247df7b74fbb0137c4bca.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Lato-regular.woff2
// module id = 768
// module chunks = 60